import React from "react";
import Heading from "../../common/Heading";
import "./review.css"; // Update the CSS file if needed

const reviews = [
  {
    id: 1,
    name: "Ally",
    rating: 5,
    comment: "Excellent service! The quality of the aluminum doors is outstanding.",
    photo: "../images/review1.jpg"
  },
  {
    id: 2,
    name: "Grace Ingabire",
    rating: 4,
    comment: "Great products, but the installation took a bit longer than expected.",
    photo: "../images/review2.jpg"
  },
  {
    id: 3,
    name: "Cesal Plandel",
    rating: 5,
    comment: "Very satisfied with the partitioning service, would highly recommend.",
    photo: "../images/review3.jpg"
  },
  {
    id: 4,
    name: "Emily uwase",
    rating: 4,
    comment: "Good experience overall, the team was professional and friendly.",
    photo: "../images/review4.jpg"
  },
  {
    id: 5,
    name: "Sophia ",
    rating: 5,
    comment: "The aluminum windows were perfect, and the team worked efficiently.",
    photo: "../images/review5.jpg"
  },
  {
    id: 6,
    name: "Maurice Mupenzi",
    rating: 4,
    comment: "I had a positive experience, but there was a slight delay in delivery.",
    photo: "../images/review6.jpg"
  },
  {
    id: 7,
    name: "Olivia ",
    rating: 5,
    comment: "Great customer support and the partitioning work was flawless.",
    photo: "../images/review7.jpg"
  },
  {
    id: 8,
    name: "James ",
    rating: 4,
    comment: "Everything was good, just wished the installation was a bit quicker.",
    photo: "../images/review8.jpg"
  },
];

const ReviewCard = ({ review }) => {
  return (
    <div className="review-card">
      <img src={review.photo} alt={review.name} className="review-photo" />
      <div className="review-header">
        <h3>{review.name}</h3>
        <div className="rating">{'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}</div>
      </div>
      <p>{review.comment}</p>
    </div>
  );
};

const Review = () => {
  return (
    <>
      <section className="review-section background">
        <div className="container">
          <Heading title="Customer Reviews" subtitle="See what our customers have to say." />
          <div className="review-grid">
            {reviews.map((review) => (
              <ReviewCard key={review.id} review={review} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Review;
